import { AppBadge } from './AppBadge';
import type { AppBadgePreset } from './appBadgeConstants';

/** Renders an `AppBadge` per value, wrapping to a new line if needed. */
export const AppBadgeList = ({ types }: { types: AppBadgePreset[] }) => {
  if (!types?.length) return null;

  return (
    <div className="flex flex-wrap items-center gap-2">
      {types.filter(Boolean).map((type, index) => (
        <AppBadge key={`${type.children}-${index}`} type={type} />
      ))}
    </div>
  );
};
